import React, { SVGProps } from "react";

export default function SupListSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5 4.75C5 5.30228 4.55228 5.75 4 5.75C3.44772 5.75 3 5.30228 3 4.75C3 4.19772 3.44772 3.75 4 3.75C4.55228 3.75 5 4.19772 5 4.75Z" fill="currentColor" />
      <path
        d="M15 5.75C15.7403 5.75 16.3866 5.3478 16.7324 4.75C16.9026 4.45583 17 4.11429 17 3.75H7C6.44772 3.75 6 4.19772 6 4.75C6 5.30228 6.44771 5.75 7 5.75H15Z"
        fill="currentColor"
      />
      <path
        d="M15 9.25C15.7403 9.25 16.3866 8.8478 16.7324 8.25C16.9026 7.95583 17 7.61429 17 7.25H7C6.44772 7.25 6 7.69772 6 8.25C6 8.80228 6.44771 9.25 7 9.25H15Z"
        fill="currentColor"
      />
      <path
        d="M16.7324 11.75C16.3866 12.3478 15.7403 12.75 15 12.75H7C6.44771 12.75 6 12.3023 6 11.75C6 11.1977 6.44772 10.75 7 10.75H17C17 11.1143 16.9026 11.4558 16.7324 11.75Z"
        fill="currentColor"
      />
      <path
        d="M15 16.25C15.7403 16.25 16.3866 15.8478 16.7324 15.25C16.9026 14.9558 17 14.6143 17 14.25H7C6.44772 14.25 6 14.6977 6 15.25C6 15.8023 6.44771 16.25 7 16.25H15Z"
        fill="currentColor"
      />
      <path d="M4 9.25C4.55228 9.25 5 8.80229 5 8.25C5 7.69772 4.55228 7.25 4 7.25C3.44772 7.25 3 7.69772 3 8.25C3 8.80229 3.44772 9.25 4 9.25Z" fill="currentColor" />
      <path d="M5 11.75C5 12.3023 4.55228 12.75 4 12.75C3.44772 12.75 3 12.3023 3 11.75C3 11.1977 3.44772 10.75 4 10.75C4.55228 10.75 5 11.1977 5 11.75Z" fill="currentColor" />
      <path d="M4 16.25C4.55228 16.25 5 15.8023 5 15.25C5 14.6977 4.55228 14.25 4 14.25C3.44772 14.25 3 14.6977 3 15.25C3 15.8023 3.44772 16.25 4 16.25Z" fill="currentColor" />
    </svg>
  );
}
